import { render, staticRenderFns } from "./ModalStaffEventMessenger.vue?vue&type=template&id=22988b48&"
import script from "./ModalStaffEventMessenger.vue?vue&type=script&lang=ts&"
export * from "./ModalStaffEventMessenger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports